import { createIcon } from '@chakra-ui/react';

export const PeopleGroupOutline = createIcon({
  displayName: 'People_Group_Outline',
  viewBox: '0 0 67.001 67.999',
  path: (
    <>
      <rect
        id="bg"
        width="63.996"
        height="64"
        transform="translate(0.002 0.999)"
        fill="transparent"
      />
      <g id="SJ-Icon-B_TeamPeople_Red_RGB" transform="translate(0.002 0.999)">
        <path
          id="Path_2345"
          data-name="Path 2345"
          d="M17.8,29.641a5.68,5.68,0,1,0-5.68-5.68A5.686,5.686,0,0,0,17.8,29.641Zm0-8.264a2.583,2.583,0,1,1-2.583,2.583A2.586,2.586,0,0,1,17.8,21.377Z"
          transform="translate(-0.641 -0.44)"
          fill="currentColor"
        />
        <path
          id="Subtraction_3"
          data-name="Subtraction 3"
          d="M18024,8695a32,32,0,1,1,15.023-60.245,4.491,4.491,0,0,0-2.521,2.191,28.575,28.575,0,0,0-12.5-2.846,28.9,28.9,0,1,0,28.9,28.9,28.543,28.543,0,0,0-2.953-12.717,4.545,4.545,0,0,0,1.973-2.905A32,32,0,0,1,18024,8695Zm24.477-47.354h0a29.2,29.2,0,0,0-2.473-3.363V8640.5h-3.879a29.007,29.007,0,0,0-2.992-2.118,1.51,1.51,0,0,1,1.373-.883h2.809a32.276,32.276,0,0,1,5.689,5.549v3.452a1.5,1.5,0,0,1-.527,1.14Z"
          transform="translate(-17992 -8631)"
          fill="currentColor"
        />
        <path
          id="Path_2347"
          data-name="Path 2347"
          d="M32.212,29.71a6.792,6.792,0,1,0-6.792-6.792A6.8,6.8,0,0,0,32.212,29.71Zm0-10.488a3.7,3.7,0,1,1-3.7,3.7A3.7,3.7,0,0,1,32.212,19.222Z"
          transform="translate(-0.215 -0.51)"
          fill="currentColor"
        />
        <path
          id="Path_2348"
          data-name="Path 2348"
          d="M46.558,29.641a5.68,5.68,0,1,0-5.68-5.68A5.686,5.686,0,0,0,46.558,29.641Zm0-8.264a2.583,2.583,0,1,1-2.583,2.583A2.586,2.586,0,0,1,46.558,21.377Z"
          transform="translate(0.281 -0.44)"
          fill="currentColor"
        />
        <path
          id="Path_2349"
          data-name="Path 2349"
          d="M57.713,40.718l-1-4.724a5.648,5.648,0,0,0-4.045-4.3,19.31,19.31,0,0,0-10.1,0,5.615,5.615,0,0,0-2.2,1.2,6.513,6.513,0,0,0-1.129-.448,24.159,24.159,0,0,0-12.934,0,6.5,6.5,0,0,0-1.125.446,5.622,5.622,0,0,0-2.2-1.2,19.332,19.332,0,0,0-10.1,0,5.65,5.65,0,0,0-4.044,4.3l-1,4.724a1.549,1.549,0,0,0,1.514,1.869H17.3a1.548,1.548,0,0,0,0-3.1H11.266l.6-2.856A2.562,2.562,0,0,1,13.7,34.677a16.185,16.185,0,0,1,8.467,0,2.553,2.553,0,0,1,.593.258A6.782,6.782,0,0,0,21.628,37.5l-1.285,6.073a1.549,1.549,0,0,0,1.515,1.869H43.691a1.55,1.55,0,0,0,1.515-1.869L43.922,37.5a6.785,6.785,0,0,0-1.132-2.563,2.489,2.489,0,0,1,.6-.26,16.189,16.189,0,0,1,8.468,0,2.561,2.561,0,0,1,1.83,1.958l.6,2.856H48.254a1.548,1.548,0,0,0,0,3.1H56.2a1.55,1.55,0,0,0,1.515-1.869ZM23.769,42.343l.89-4.2a3.542,3.542,0,0,1,2.485-2.714,21.039,21.039,0,0,1,11.264,0,3.539,3.539,0,0,1,2.484,2.714l.891,4.2H23.769Z"
          transform="translate(-0.779 -0.032)"
          fill="currentColor"
        />
      </g>
      <path
        id="Union_1"
        data-name="Union 1"
        d="M7,16.5v-6H1.5a1.5,1.5,0,1,1,0-3H7v-6a1.5,1.5,0,0,1,3,0v6h5.5a1.5,1.5,0,1,1,0,3H10v6a1.5,1.5,0,0,1-3,0Z"
        transform="translate(47.002)"
        fill="currentColor"
      />
    </>
  ),
});

export const PeopleGroup = createIcon({
  displayName: 'People_Group',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect
        xmlns="http://www.w3.org/2000/svg"
        id="bg"
        width="24"
        height="24"
        transform="translate(0)"
        fill="none"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        id="People_Group_-_L"
        data-name="Avatars People Group - L"
        d="M19.531,21.888a2.854,2.854,0,1,0-2.854-2.854A2.854,2.854,0,0,0,19.531,21.888Zm0-4.572a1.718,1.718,0,1,1-1.718,1.718A1.718,1.718,0,0,1,19.531,17.316ZM12.677,21.8a3.228,3.228,0,1,0-3.228-3.228A3.228,3.228,0,0,0,12.677,21.8Zm0-5.321a2.093,2.093,0,1,1-2.093,2.093A2.093,2.093,0,0,1,12.677,16.475ZM24.648,26.35l-.481-1.767a2.844,2.844,0,0,0-2.415-2.044,11.021,11.021,0,0,0-2.2-.254,9.7,9.7,0,0,0-1.514.125.571.571,0,0,0,.174,1.128,8.913,8.913,0,0,1,3.3.121,1.772,1.772,0,0,1,1.54,1.23l.435,1.59H19.531a.568.568,0,0,0,0,1.135h4.14a1,1,0,0,0,.976-1.264ZM5.819,21.888a2.854,2.854,0,1,0-2.854-2.854,2.854,2.854,0,0,0,2.854,2.854Zm0-4.572A1.718,1.718,0,1,1,4.1,19.034a1.718,1.718,0,0,1,1.718-1.718ZM18.52,27.1l-.564-2.048a3.207,3.207,0,0,0-2.733-2.309,12.8,12.8,0,0,0-2.54-.3,12.826,12.826,0,0,0-2.555.3A3.207,3.207,0,0,0,7.4,25.052l-.564,2.055a1.067,1.067,0,0,0,1.029,1.351h9.628A1.067,1.067,0,0,0,18.52,27.11Zm-10.567.223.537-1.968a2.17,2.17,0,0,1,1.866-1.514,11.774,11.774,0,0,1,2.328-.272A11.5,11.5,0,0,1,15,23.84a2.127,2.127,0,0,1,1.866,1.514l.537,1.968Zm-2.135-.84H1.864l.454-1.6a1.761,1.761,0,0,1,1.54-1.23,8.9,8.9,0,0,1,3.293-.121.575.575,0,0,0,.178-1.135,9.7,9.7,0,0,0-1.514-.125,11.1,11.1,0,0,0-2.2.254A2.839,2.839,0,0,0,1.2,24.567L.721,26.35a.992.992,0,0,0,.961,1.257H5.819a.568.568,0,1,0,0-1.135Z"
        transform="translate(-0.685 -9.899)"
        fill="currentColor"
      />
    </>
  ),
});
